import API from './API';

export default {

    findUnities() {
        return API.get("/unities")
    }

}
